module.exports = san.defineComponent({
    template: require('../views/alert.html'),
    initData: function() {
        return {
            showAlert: false,
            showTip: false,
            type:'',
            title:'',
            message:''
        };
    },
    components: {

    },
    created: function() {

    },
    show: function(title,message,type) {
        this.data.set('title',title);
        this.data.set('message',message);
        this.data.set('type',type);
        this.data.set('showAlert',true);
    },
    close: function() {
        this.data.set('showAlert',false);
    },
    messages:{

    }
});


//////////////////
// WEBPACK FOOTER
// ./src/components/alert.js
// module id = 97
// module chunks = 1